module.exports = __webpack_public_path__ + "static/media/TsugaAudio_005b-green.541b6ebd.png";